import React from 'react';

import NotSavedIcon from '../../assets/images/SaveIcon-NotSaved.svg';
import SavedIcon from '../../assets/images/SaveIcon-Saved.svg';
import NotSavedHoverIcon from '../../assets/images/SaveIcon-Hover.svg';
import SavedHoverIcon from '../../assets/images/SaveIcon-Saved-Hover.svg';

// Bookmark toggle shared by the Investor Profile header (Figma "save
// investor", 992:36162, 24x24) and the Search result card (34:3141, "save
// investor" I34:3141;1047:55170, 30x30) — same glyph swapping Saved/NotSaved
// icons, sized per usage via `className`/`iconClassName`.
//
// Optional pill variant (map card, ATAI-451): `label` renders a text span
// and `hoverIconClassName` adds the white hover glyph alongside the resting
// one, so the caller's CSS can expand it on hover. Omitted, the markup is
// exactly the plain icon button above.
const SaveInvestorButton = ({
  saved,
  onToggle,
  className,
  iconClassName,
  label,
  labelClassName,
  hoverIconClassName,
}) => (
  <button
    type="button"
    className={className}
    onClick={onToggle}
    aria-pressed={saved}
    aria-label={saved ? 'Remove investor from saved' : 'Save investor'}
  >
    {!label ? null : <span className={labelClassName}>{label}</span>}
    <img src={saved ? SavedIcon : NotSavedIcon} className={iconClassName} alt="" />
    {!hoverIconClassName ? null : (
      <img
        src={saved ? SavedHoverIcon : NotSavedHoverIcon}
        className={hoverIconClassName}
        alt=""
      />
    )}
  </button>
);

export default SaveInvestorButton;
